<!--
TODO
* Transitions/animations
  * To views
  * To filters @ results view
  * To filterSelection (change/close|enter differently)
* Add awaits/async stuff, too fast so it fails / loads some other endpoint first and gets messed
* Refactor
-->
<template>
  <!--<div :key="$route.fullPath">-->
  <div class="search">
    <div class="search__content">
      <div
        v-if="$route.name === 'Search' || $route.name === 'Datasets'"
        :key="'SEARCH_DATASETS_' + searchToken.datasets + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
        :class="['search__datasets', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
      >
        <AppDatasets
          title="Datasets"
          :results="results.datasets"
          :paginator="meta.datasets.paginator"
          :loading="loading.datasets"
          :timeout="timeout.datasets"
          :noResults="noResults.datasets"
          @itemClicked="itemClicked"
          @controlsChanged="toggleControls"
          @paginatorChanged="datasetsPaginatorChanged"
        />
      </div>

      <div
        v-if="$route.name === 'Search' || $route.name === 'PDFs'"
        :key="'SEARCH_PDFS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
        :class="['search__pdfs', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
      >
        <AppPDFs
          title="Reports"
          :results="$route.name === 'Search' ? results.pdfs : results.pdfs"
          :paginator="meta.pdfs.paginator"
          :loading="loading.pdfs"
          :timeout="timeout.pdfs"
          :noResults="noResults.pdfs"
          @itemClicked="itemClicked"
          @controlsChanged="toggleControls"
          @paginatorChanged="PDFsPaginatorChanged"
        />
      </div>

      <div
        v-if="$route.name === 'Search' || $route.name === 'News'"
        :key="'SEARCH_NEWS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
        :class="['search__news', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
      >
        <AppNews
          :key="'SEARCH_NEWS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
          title="News"
          :results="$route.name === 'Search' ? results.news : results.news"
          :paginator="meta.news.paginator"
          :loading="loading.news"
          :timeout="timeout.news"
          :noResults="noResults.news"
          @itemClicked="itemClicked"
          @controlsChanged="toggleControls"
          @paginatorChanged="newsPaginatorChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppDatasets from '@/components/app/Datasets.vue'
import AppPDFs from '@/components/app/PDFs.vue'
import AppNews from '@/components/app/News.vue'
import helperMethods from '@/helpers/utility.js'
import { downloadPost } from '@/helpers/http'

export default {
  components: {
    AppDatasets,
    AppPDFs,
    AppNews
  },
  metaInfo () {
    return {
      title: 'Statzon App | Global Industry & Technology Insights & Data',
    }
  },
  data () {
    return {
      initialized: false,
      loading: {
        datasets: true,
        pdfs: true,
        news: true
      },
      timeout: {
        datasets: false,
        pdfs: false,
        news: true
      },
      noResults: {
        datasets: false,
        pdfs: false,
        news: false
      }
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    getSubscriptionStatus () {
      return this.$store.getters['user/getSubscriptionStatus']
    },
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    selectedView () { // TODO: Not used?
      return this.$store.getters['search/getSelectedView']
    },
    selectedHash () {
      return this.$store.getters['search/getSelectedHash']
    },
    results () {
      return this.$store.getters['search/getResults']
    },
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    },
    selectedFiltersCount () {
      let query = false
      let filters = 0

      if (this.selectedFilters) {
        for (const [key, value] of Object.entries(this.selectedFilters)) {
          if (this.selectedFilters[key] && this.selectedFilters[key].length > 0) {
            if (key === 'queries') {
              query = true
            } else {
              filters += this.selectedFilters[key].length
            }
          }
        }
      }

      return (query === true ? 'Freetext' : '') + (query && filters > 0 ? ' + ' : '') + (filters > 0 ? filters + (filters === 1 ? ' filter' : ' filters') : '')
    },
    meta () {
      return this.$store.getters['search/getMeta']
    },
    pageTitle () {
      let title = 'Search'

      /* TODO: Redo, not working anymore...
      if (this.selectedView === 'search') {
        title = 'Search / Page ' + this.meta.paginator.current_page
      } else if (this.selectedView === 'datasets') {
        let resourceTitle = this.selectedHash !== false ? ' / ' + this.results.byId[this.selectedHash].attributes.title : ''
        title = 'Dataset' + resourceTitle
      } else if (this.selectedView === 'pdfs') {
        let resourceTitle = this.selectedHash !== false ? ' / ' + this.results.byId[this.selectedHash].attributes.title : ''
        title = 'PDF' + resourceTitle
      } else if (this.selectedView === 'filters') {
        let fixedFilters = { 'topics': 'Topics', 'locations': 'Locations', 'trade_types': 'Trades', 'scales': 'Scales', 'providers': 'Providers' }
        title = fixedFilters[this.activeFilter] + ' / Page ' + this.filtersMeta.current_page
      }*/

      return title
    }
  },
  watch: {
    $route (to, from) {
      let analytics = true
      this.initialize()

      if (to.name === 'Datasets' || to.name === 'Search') {
        this.search('datasets', true, analytics)
        analytics = false
      } if (to.name === 'PDFs' || to.name === 'Search') {
        this.search('pdfs', true, analytics)
        analytics = false
      } if (to.name === 'News' || to.name === 'Search') {
        this.search('news', true, analytics)
        analytics = false
      }
    }
  },
  methods: {
    search (type, silent, analytics) {
      this.$store.dispatch('search/setSearchToken', { 'type': type, 'url': false })

      if (!this.results[type] || this.searchToken[type] !== this.meta[type].parameters.search_token) {
        this.$store.dispatch('search/fetchResults', type).then(response => {
          let checkResults = this.results[type]
          this.loading[type] = false

          if (checkResults.allIds.length === 0) {
            this.noResults[type] = true
            this.timeout[type] = false
          } else {
            this.noResults[type] = false
            this.timeout[type] = false
          }

          if (!silent) {
            this.$router.push('/'+ type + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](type, 'client'))
          }

          if (analytics && this.$store.getters['search/getFiltersQuery']('search', 'client') !== '') {
            this.sendGoogleAnalyticsEvent('search_filters_count', this.selectedFiltersCount, this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
          }

          if (this.$store.getters['search/getFiltersQuery']('search', 'client') !== '') {
            this.sendGoogleAnalyticsEvent('search_' + type, this.selectedFiltersCount, this.meta[type].paginator.total, this.$store.getters['user/getSubscriptionStatus'])
          }

          return true
        }).catch(error => {
          this.timeout[type] = true
          this.loading[type] = false
        })
      } else {
        this.timeout[type] = false
        this.loading[type] = false
      }

      return false
    },
    datasetsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'datasets', value: newPage })
      this.$router.push('/datasets?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('datasets', 'client'))
    },
    PDFsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'pdfs', value: newPage })
      this.$router.push('/pdfs?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('pdfs', 'client'))
    },
    newsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'news', value: newPage })
      this.$router.push('/news?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('news', 'client'))
    },
    itemClicked (value) {
      /* This only works with first item selection. Maybe component "linking" breaks when views are changed. Theses analytics events are now moved to LayoutGrid, UtilityList and UtilityRelatedSlider */
      // let name = this.results[value.type].byId[value.hash].attributes.title ? this.results[value.type].byId[value.hash].attributes.title : (this.results[value.type].byId[value.hash].attributes.name ? this.results[value.type].byId[value.hash].attributes.name : value.id)
      //this.sendGoogleAnalyticsEvent(value.type, 'Search Selection', name, false, this.$store.getters['user/isAuthenticated'], this.$store.getters['user/getSubscriptionStatus'])
    },
    toggleControls (setting, value) {
      let settingType = setting.split('.')[0]
      let settingName = setting.split('.')[1]

      if (setting !== 'datasets.download') {
        this.$store.dispatch('app/setSettings', { 'name': setting, 'value': value })
      }

      if (setting === 'datasets.download') {
        this.downloadAllAsExcel()
      }

      if (setting === 'search.view') {
        if (['search', 'datasets', 'pdfs', 'news'].includes(value)) {
          if (value === 'search') {
            this.$router.push('/' + value + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client'))
          } else {
            this.$router.push('/' + value + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](value, 'client'))
          }
        }
      }

      if (settingName === 'display') {
        // TODO: This triggers API reload, figure out to change URL silently without breaking stuff
        this.$router.push('/' + settingType + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](settingType, 'client'))
      }

      if (settingName === 'sort' || settingName === 'access') {
        this.$store.dispatch('search/setPageNumber', { type: settingType, value: 1 })
        this.$router.push('/' + settingType + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](settingType, 'client'))
      }
    },
    downloadAllAsExcel () {
      let parameters = {
        datasets: this.$store.getters['search/getLicensedDatasets']
      }

      downloadPost('downloads/datasets', parameters).then(response => {
        let blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        var date = new Date()
        let fileName = 'statzon_' + date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + '_' + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2) + '.xlsx'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(error => {
        this.excelError = error.errors
      })

      this.sendGoogleAnalyticsEvent('download_datasets_mass', false, false, this.$store.getters['user/getSubscriptionStatus'])
    },
    initialize () {
      this.loading = {
        'datasets': true,
        'pdfs': true,
        'news': true
      }

      let parsedQuery = this.$store.getters['search/parseQuery'](true)
      let view = this.$route.name.toLowerCase()
      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': view })
      this.$store.dispatch('search/setPageNumber', { type: view, value: parsedQuery.controls.page ? parsedQuery.controls.page : 1 })
      this.$store.dispatch('search/setSelectedFilters', parsedQuery.filters)

      if (Object.keys(parsedQuery.controls).length > 0) {
        Object.keys(parsedQuery.controls).forEach(function (key) {
          if (parsedQuery.controls[key] !== false) {
            this.$store.dispatch('app/setSettings', { 'name': view + '.' + key, 'value': parsedQuery.controls[key] })
          } else if (key !== 'after_id' && key !== 'before_id') {
            this.$store.dispatch('app/setSettings', { 'name': view + '.' + key, 'value': 'all' })
          }
          // TODO: u need to add default otherwise -> load defaults as base first /deep/ add all params always not just set ones
        }.bind(this))
      }
    },
    ...helperMethods
  },
  mounted () {
    this.initialize()
    this.search('datasets', true, false)
    this.search('pdfs', true, false)
    this.search('news', true, false)
    this.sendGoogleAnalyticsEvent('search_filters_count', this.selectedFiltersCount, this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.search {
  width: 100%;
  height: auto;
  margin: 0 auto 64px auto;

  @media screen and (min-width: $breakpointSm) {
    margin: 0 auto 464px auto;
  }

  .search__results--front {
    &:hover /deep/.controls {
      .button {
        background-color: $bg-1;
      }

      .button__icon {
        fill: $blue;
      }

      .button__text-icon {
        color: $white;
      }
    }
  }

  &__content {
    width: 100%;
    max-width: $xlContentWidth;
    border-width: 1px 1px 0 1px;
    border-color: $black;
    border-style: solid;
    margin: 144px auto 60px auto;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23); // TODO: Tweak...

    @media screen and (min-width: $breakpointSm) {
      width: calc(100% - 32px);
      margin: 100px auto 60px auto;
    }

    @media screen and (min-width: $breakpointLg) {
      margin: 108px auto 68px auto;
    }
  }
}

</style>
